AppTabs.createTab( {
name: 'price-list',
icon: 'list-alt',
text: 'Price List',
create: function(init) {
	'use strict'

	init.setDataTableArgs( {

		tableId: 		'#data-table-price-list',

		readTableName: 	'tblPriceList',
		editTableName: 	'tblPriceList',
		primaryKey: 	'PriceListID',

		hasColumnFilters: 	true,
		canSearch: 			true,
		canSort:			true,

		actionData:			'datatable',
		actionAutofill: 	'datatable_autofill',
		actionCreate:		'datatable_create',
		actionEdit:			'datatable_edit',
		actionRemove:		'datatable_remove',

		editCallback:		function() {
			window.broadcastLocalStorageUpdateRequest( 'priceList' );
		},

		fields: [
			{
				label: 		'Item',
				columnName: 'Item',
				isEditable: true,
				order: 		'asc',
			},
			{
				label: 		'Category',
				columnName: 'Category',
				isEditable: true,
			},
			{
				label: 		'Tested Substance',
				columnName: 'TestedSubstance',
				isEditable: true,
			},
			{
				label: 		'Notes',
				columnName: 'Notes',
				isEditable: true,
			},
			{
				label: 		'Charge',
				columnName: 'Charge',
				isEditable: true,
			},
			{
				label: 		'Method',
				columnName: 'Method',
				isEditable: true,
			},
		],

	} );
}

} );
